import { memo } from "react";

export const getMobileTruncated = (text: string, maxChars: number, nEllipsis?: number) => {
    if (text.length <= maxChars) return text;
    return text.slice(0, maxChars) + ".".repeat(nEllipsis ?? 1);
};

const MobileTruncatedComponent = ({
    desktopText,
    mobileMaxChars,
    nEllipsis,
}: {
    desktopText: string;
    mobileMaxChars: number;
    nEllipsis?: number;
}) => {
    const shortened = getMobileTruncated(desktopText, mobileMaxChars, nEllipsis);

    return (
        <>
            <span className="hidden sm:inline">{desktopText}</span>
            <span className="inline sm:hidden">{shortened}</span>
        </>
    );
};

export const MobileTruncated = memo(MobileTruncatedComponent);

MobileTruncated.displayName = "MobileTruncated";
